import api from "@/api.js";

export default {
  state: {
    scheduledSurveys: [],
    scheduledSurveysLoading: false,
    pastSurveys: [],
    pastSurveysLoading: false,
    surveys: [],
    surveysLoading: false,
    currentSurvey: {},
    recentLocations: [],
    recentLocationsLoading: false,
    nearestLocations: [],
    nearestLocationsLoading: false,
    organizationSurveyLinks: [],
    organizationSurveyLinksLoading: false,
    survey: null,
    surveyLoading: false,
    scansToBeReProcessed: [],
    scansToBeReProcessedLoading: false,
  },
  mutations: {
    setScheduledSurveys(state, payload) {
      state.scheduledSurveys = payload;
    },
    setScheduledSurveysLoading(state, payload) {
      state.scheduledSurveysLoading = payload;
    },
    setPastSurveys(state, payload) {
      state.pastSurveys = payload;
    },
    setPastSurveysLoading(state, payload) {
      state.pastSurveysLoading = payload;
    },
    setSurveys(state, payload) {
      state.surveys = payload;
    },
    setSurveysLoading(state, payload) {
      state.surveysLoading = payload;
    },
    setCurrentSurvey(state, payload) {
      state.currentSurvey = payload;
    },
    setRecentLocations(state, payload) {
      state.recentLocations = payload;
    },
    setRecentLocationsLoading(state, payload) {
      state.recentLocationsLoading = payload;
    },
    setNearestLocations(state, payload) {
      state.nearestLocations = payload;
    },
    setNearestLocationsLoading(state, payload) {
      state.nearestLocationsLoading = payload;
    },
    setOrganizationSurveyLinks(state, payload) {
      state.organizationSurveyLinks = payload;
    },
    setOrganizationSurveyLinksLoading(state, payload) {
      state.organizationSurveyLinksLoading = payload;
    },
    setSurvey(state, payload) {
      state.survey = payload;
    },
    setSurveyLoading(state, payload) {
      state.surveyLoading = payload;
    },
    setScansToBeReProcessed(state, payload) {
      state.scansToBeReProcessed = payload
    },
    setScansToBeReProcessedLoading(state, payload) {
      state.scansToBeReProcessedLoading = payload
    }
  },
  actions: {
    async loadScheduledSurveys({ commit }) {
      commit("setScheduledSurveysLoading", true);
      let scheduledSurveys = await api.get("scheduledSurveys");
      commit("setScheduledSurveys", scheduledSurveys.data);
      commit("setScheduledSurveysLoading", false);
    },
    async loadSurveys({ commit }) {
      commit("setSurveysLoading", true);
      let surveys = await api.get("surveys");
      commit("setSurveys", surveys.data);
      commit("setSurveysLoading", false);
    },
    async loadSurveyByID({ commit }, id) {
      commit("setSurveyLoading", true);
      // console.log("Loading Survey");
      let survey = await api.get("surveys/byID", {
        params: {
          id: id
        }
      });
      commit("setSurvey", survey.data[0]);
      commit("setSurveyLoading", false);
    },
    async loadPastSurveys({ commit }, loadAll = '') {
      commit("setPastSurveysLoading", true);
      let pastSurveys = await api.get("scheduledSurveys/pastSurveys", {
        params: {
          loadAll: loadAll
        }
      });
      commit("setPastSurveys", pastSurveys.data);
      commit("setPastSurveysLoading", false);
    },
    async loadOrganizationSurveyLinks({ commit }) {
      commit("setOrganizationSurveyLinksLoading", true);
      let links = await api.get("scheduledSurveys/organizationSurveyLinks");
      commit("setOrganizationSurveyLinks", links.data);
      commit("setOrganizationSurveyLinksLoading", false);
    },
    async newScheduledSurvey({ dispatch, state }, payload) {
      let returnData = {};
      await api
        .post("scheduledSurveys", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
            let currentSurvey = state.currentSurvey;
            currentSurvey.id = response.data.id;
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadScheduledSurveys");
      dispatch("loadSurveys");

      return returnData;
    },
    async saveScheduledSurvey({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`scheduledSurveys`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadScheduledSurveys");
      dispatch("loadSurveys");

      return returnData;
    },
    async resetScheduledSurveyTempPassword({ dispatch }, payload) {
      api.post(`scheduledSurveys/resetTempPassword`, payload);
    },
    async uploadSurveyScanData({ dispatch }, payload) {
      let response = await api.post(`scans/uploadScan`, payload);
      dispatch("loadSurveys");
      dispatch("loadScheduledSurveys");
      dispatch("loadPastSurveys");
      return response;
    },
    async setCurrentSurvey({ commit }, payload) {
      commit("setCurrentSurvey", payload);
    },
    async loadRecentLocations({ commit }) {
      commit("setRecentLocationsLoading", true);
      let recentLocations = await api.get("scheduledSurveys/recentLocations");
      commit("setRecentLocations", recentLocations.data);
      commit("setRecentLocationsLoading", false);
    },
    async linkToScheduledSurveys({ dispatch }, payload) {
      let returnData;
      await api
        .post(`scheduledSurveys/link`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadScheduledSurveys");
      dispatch("loadSurveys");
      dispatch("loadPastSurveys");
      return returnData;
    },
    async loadNearestLocations({ commit }, payload) {
      commit("setNearestLocationsLoading", true);
      let nearestLocations = await api.get(
        "scheduledSurveys/nearestLocations",
        { params: payload }
      );
      commit("setNearestLocations", nearestLocations.data);
      commit("setNearestLocationsLoading", false);
    },
    async createMergedSurvey({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post(`scheduledSurveys/createMergedSurvey`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadScheduledSurveys");
      dispatch("loadSurveys");
      dispatch("loadPastSurveys");
      return returnData;
    },
    async splitSurvey({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post(`scheduledSurveys/splitSurvey`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async loadScansNeedingReProcessing({ commit, dispatch }) {
      commit("setScansToBeReProcessedLoading", true);
      let apiResponse = await api.get("scheduledSurveys/scansToBeReProcessed");
      commit("setScansToBeReProcessed", apiResponse.data);
      commit("setScansToBeReProcessedLoading", false);
    },
    async createScanReprocessJob({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post(`scheduledSurveys/createScanReprocessJob`, payload)
        .then(response => {
          returnData = {
            Result: "Success",
            Response: response.data
          };
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    scheduledSurveys(state) {
      return state.scheduledSurveys;
    },
    scheduledSurveysLoading(state) {
      return state.scheduledSurveysLoading;
    },
    pastSurveys(state) {
      return state.pastSurveys;
    },
    pastSurveysLoading(state) {
      return state.pastSurveysLoading;
    },
    surveys(state) {
      return state.surveys;
    },
    surveysLoading(state) {
      return state.surveysLoading;
    },
    currentSurvey(state) {
      return state.currentSurvey;
    },
    recentLocations(state) {
      return state.recentLocations;
    },
    recentLocationsLoading(state) {
      return state.recentLocationsLoading;
    },
    nearestLocations(state) {
      return state.nearestLocations;
    },
    nearestLocationsLoading(state) {
      return state.nearestLocationsLoading;
    },
    organizationSurveyLinks(state) {
      return state.organizationSurveyLinks;
    },
    organizationSurveyLinksLoading(state) {
      return state.organizationSurveyLinksLoading;
    },
    survey(state) {
      return state.survey;
    },
    surveyLoading(state) {
      return state.surveyLoading;
    },
    scansToBeReProcessed(state) {
      return state.scansToBeReProcessed
    },
    scansToBeReProcessedLoading(state) {
      return state.scansToBeReProcessedLoading
    },
  }
};
